<div *ngIf="state === 0" style="background-color: rgb(21, 201, 201); height: 5px;"></div>
<div *ngIf="state === 1" style="background-color: rgb(0, 152, 223); height: 5px;"></div>
<div *ngIf="state === 2" style="background-color: rgb(222, 226, 0); height: 5px;"></div>
<div style="background-color: #fff;">
  <div class="btn-group btn-group-toggle barra" data-toggle="buttons">
    <label translate *ngIf="!modoEdicao" class="btn btn-secondary" (click)="voltar()">
        <em  class="fa fa-arrow-left"></em> {{'barraCrud.voltar'}}
    </label>
    <label translate *ngIf="!modoEdicao && exibirNovo" class="btn btn-secondary" (click)="inserir()">
        <em class="fa fa-plus"></em> {{'barraCrud.novo'}}
    </label>
    <label translate *ngIf="modoEdicao" class="btn btn-secondary" (click)="salvar()">
        <em  class="fa fa-save"></em> {{'barraCrud.salvar'}}
    </label>
    <label translate *ngIf="!modoEdicao" class="btn btn-secondary" (click)="editar()">
        <em  class="fas fa-pencil-alt"></em> {{'barraCrud.editar'}}
    </label>
    <label translate *ngIf="modoEdicao" class="btn btn-secondary"(click)="cancelar()">
        <em  class="fa fa-ban"></em> {{'barraCrud.cancelar'}}
    </label>
    <label translate *ngIf="!modoEdicao && exibirExcluir" class="btn btn-secondary" (click)="excluir()">
        <em  class="fa fa-trash"></em> {{'barraCrud.excluir'}}
    </label>
  </div>
</div>